<div class="forecast-dialog-header">
    <div class="header__wrapper">
        <div class="forecast-title">
            Weather Forecast for <span>{{ city }}</span> @if (!city) { <span>{{ lngLat | latLng }}</span> }

            <button mat-icon-button (click)="editLocation()" [matTooltip]="'Edit Location'">
                <mat-icon>edit</mat-icon>
            </button>
        </div>
        <div class="actions">
            <button mat-icon-button (click)="loadData()" [matTooltip]="'Reload the forecast'">
                <mat-icon>refresh</mat-icon>
            </button>
            <button mat-icon-button mat-dialog-close cdkfocusinitial
                aria-label="close">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>

<div mat-dialog-content>
    <h2>5-Day Forecast</h2>
    <div class="flex-column mb-32">
      @for (forecastData of dailyData; track $index) {
        @if ($index < 10) {
          <div class="flex-row align-items-center gap-32">
            <div style="width: 80px">
              {{ forecastData.name }}
            </div>

            <img [ngSrc]="getIconUrl(forecastData.icon)"
                 width="86"
                 height="86"
                 [alt]="forecastData.name"
                 [matTooltip]="forecastData.detailedForecast"/>

            <div style="width: 16px">
              {{ forecastData.temperature }}°{{ forecastData.temperatureUnit}}
            </div>

            <div style="max-width: 350px">
              {{ forecastData.shortForecast}}
            </div>
          </div>
        }
      }
    </div>

    <h2>24-Hour Forecast</h2>
    <div class="flex-column">
      @for (hourData of hourlyData; track $index) {
        <div class="flex-row align-items-center gap-32">
          <div style="width: 80px">
            {{ hourData.startTime | date: 'shortTime' }}
          </div>

          <div style="width: 86px">
            <img [ngSrc]="getIconUrl(hourData.icon)"
                 width="56"
                 height="56"
                 [alt]="hourData.startTime | date: 'shortTime'"
            >
          </div>

          <div style="width: 16px">
            {{ hourData.temperature }}°{{ hourData.temperatureUnit}}
          </div>

          <div style="max-width: 350px">
            {{ hourData.shortForecast}}
          </div>
        </div>
      }
    </div>
</div>


